export const QUICK_FILTER_TIN_URL = '/standard-search/topfilter';